module.exports = __webpack_public_path__ + "static/media/Caixa3.be2a755e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa3.png
// module id = 2032
// module chunks = 0